__turbopack_context__.v({
  "content": "not-found-module-scss-module__2jWFaq__content",
  "error": "not-found-module-scss-module__2jWFaq__error",
  "link": "not-found-module-scss-module__2jWFaq__link",
  "notFoundPage": "not-found-module-scss-module__2jWFaq__notFoundPage",
  "stamp": "not-found-module-scss-module__2jWFaq__stamp",
  "subtitle": "not-found-module-scss-module__2jWFaq__subtitle",
  "title": "not-found-module-scss-module__2jWFaq__title",
});
